<script setup lang="ts">
import { ref } from 'vue';
import { asyncVueComponent } from '@nio-fe/mate-lib-loader';
import { useCouponStore } from '@/store/couponStore';

const TitContactTransfer = asyncVueComponent(
  '@nio-wad/ladybird',
  '0',
  'TitContactTransfer'
);

interface ContactSelectionDialogProps {
  primaryText?: string;
  secondaryText?: string;
  title?: string;
  beforeSubmit: (value: any) => void | boolean | Promise<boolean>;
}

const props = withDefaults(defineProps<ContactSelectionDialogProps>(), {
  primaryText: '确定',
  secondaryText: '取消',
  title: '选择人员',
});

const emit = defineEmits(['success']);
const couponStore = useCouponStore();
const contactSelectionRef = ref<any>(null);
const globalLoading = ref(false);
const dialogVisible = ref(false);
const defaultLocalValue = {
  selected: [],
  value: {},
  searchInputValue: '',
};
const localValue = ref(defaultLocalValue);
const handleChange = (value) => {
  localValue.value = value;
};
const showDialog = (defaultValue) => {
  dialogVisible.value = true;
  if (defaultValue) {
    defaultLocalValue.value = defaultValue;
  }
};
const closeDialog = () => {
  dialogVisible.value = false;
  localValue.value = defaultLocalValue;
};

const queryColleagues = ({ keywords, limit, currentPage }) => {
  return contactSelectionRef.value
    .defaultColleagueRequestAction({
      keywords,
      limit,
      currentPage,
      // /*TODO: queryType: search*/
    })
    .then((data) => {
      data.forEach((i) => {
        // i.value = i.accountId || '';
        const accountId =
          i?.brands?.find((i) => i.brand === couponStore.currentBrand)
            ?.accountId || '';
        i.value = accountId;
        i.accountId = accountId;
      });
      return data;
    });
};

const handleFinished = async () => {
  if (props.beforeSubmit) {
    let value = props.beforeSubmit(localValue.value);
    if (value instanceof Promise) {
      try {
        globalLoading.value = true;
        value = await value.then();
      } finally {
        globalLoading.value = false;
      }
    }
    if (value === false) {
      return;
    }
  }
  emit('success', localValue.value);
  dialogVisible.value = false;
  localValue.value = defaultLocalValue;
};

defineExpose({
  showDialog,
  closeDialog,
});
</script>

<template>
  <n-dialog
    display-type="if"
    :title="title"
    size="large"
    v-model="dialogVisible"
    @primary-click="handleFinished"
    @secondary-click="closeDialog"
    :primary-button-props="{
      disabled: !localValue.selected.length || globalLoading,
    }"
    :primary-text="primaryText"
    :secondary-text="secondaryText"
  >
    <tit-contact-transfer
      v-loading="{ isShow: globalLoading }"
      ref="contactSelectionRef"
      :colleagueRequestAction="queryColleagues"
      :brand="couponStore.currentBrand"
      :default-value="localValue"
      @change="handleChange"
    />
  </n-dialog>
</template>

<style scoped lang="scss"></style>
